document.addEventListener('change', (e) => {
  const input = e.target;
  if (!input.matches('input[type="file"][name^="properties["]')) return;

  // 既存の表示を消す/作る
  let status = input.closest('.upload-label')?.querySelector('.upload-status');
  if (!status) {
    status = document.createElement('div');
    status.className = 'upload-status';
    input.closest('.upload-label')?.appendChild(status);
  }

  const file = input.files && input.files[0];
  if (file) {
    status.textContent = `✅ Attached: ${file.name}`;
    status.setAttribute('data-has-file', 'true');
  } else {
    status.textContent = '';
    status.setAttribute('data-has-file', 'false');
  }
});